import { Component, inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataChatService } from '../../service/dataChat.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
   selector: 'app-poi-sidebar',
   standalone: true,
   imports: [CommonModule],
   template: `
    <div class="poi-sidebar" *ngIf="dataChat.isPoiSidebarOpen()" [class.collapsed]="isCollapsed()">
       
       <!-- Expand Button (Visible only when collapsed) -->
       <button *ngIf="isCollapsed()" class="expand-btn" (click)="toggleCollapse()" title="Expandir">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
             <path d="M19 12H5M12 19l-7-7 7-7"/> 
          </svg>
       </button>

       <!-- Main Content (Hidden when collapsed) -->
       <div class="sidebar-content" *ngIf="!isCollapsed()">
          <!-- Header -->
          <div class="poi-header">
             <div class="poi-info">
                <h4>{{ currentPoi?.poi_name }}</h4>
                <span class="badge" *ngIf="!currentPoi?.is_fallback_web">{{ currentPoi?.poi_type === 'event' ? 'EVENTO' : 'PUNTO DE INTERÉS' }}</span>
                <span class="badge" *ngIf="currentPoi?.is_fallback_web">WEB</span>
             </div>
             <div class="header-actions">
                <button class="action-btn" (click)="toggleCollapse()" title="Colapsar">
                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                   </svg>
                </button>
                <button class="action-btn close-fully" (click)="close()" title="Cerrar">
                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                   </svg>
                </button>
             </div>
          </div>

          <!-- Iframe -->
          <div class="poi-content">
             <iframe [src]="iframeSrc()" frameborder="0" sandbox="allow-scripts allow-same-origin allow-forms allow-popups"></iframe>
          </div>

          <!-- Footer -->
          <div class="poi-footer">
             <a [href]="currentPoi?.poi_url || currentPoi?.url" target="_blank" class="external-link">
                <span>Abrir web original</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                   <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3"/>
                </svg>
             </a>
             
             <div class="nav-controls">
                <button (click)="prev()" [disabled]="dataChat.activePoiIndex() === 0">‹</button>
                
                <div class="dots">
                   <span *ngFor="let p of dataChat.poiList(); let i = index" 
                         [class.active]="i === dataChat.activePoiIndex()"
                         (click)="setActive(i)">
                   </span>
                </div>

                <button (click)="next()" [disabled]="dataChat.activePoiIndex() === dataChat.poiList().length - 1">›</button>
             </div>
          </div>
       </div>
    </div>
  `,
   styles: [`
    .poi-sidebar {
       position: fixed;
       left: 20px;
       top: 20px;
       width: calc(100% - 600px);
       min-width: 350px;
       height: calc(100% - 30px);
       background: #ffffff;
       border: 1px solid #e2e8f0;
       border-radius: 12px;
       display: flex;
       flex-direction: column;
       overflow: hidden;
       box-shadow: -4px 0 24px rgba(0,0,0,0.1);
       z-index: 9999;
       transition: width 0.3s cubic-bezier(0.16, 1, 0.3, 1), transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
       pointer-events: auto;
    }

    .poi-sidebar.collapsed {
       width: 60px; /* Reduced width for collapsed state */
       background: transparent;
       border: none;
       box-shadow: none;
       overflow: visible;
       right: 101%;
    }

    .sidebar-content {
       display: flex;
       flex-direction: column;
       height: 100%;
       width: 100%;
    }

    .expand-btn {
       width: 55px;
       height: 55px;
       border-radius: 50%;
       background: var(--primary, #1976D2);
       color: #fff;
       border: 3px solid #fff;
       display: flex;
       align-items: center;
       justify-content: center;
       cursor: pointer;
       box-shadow: 0 4px 15px rgba(0,0,0,0.3);
       transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
       margin-top: 20px;
       margin-left: auto;
    }
    .expand-btn:hover {
       transform: scale(1.1) rotate(-10deg);
       background: var(--primary-dark, #333);
    }

    .poi-header {
       padding: 0 2rem; 
       background: var(--primary, #1976D2); 
       color: white;
       display: flex;
       justify-content: space-between;
       align-items: center;
       border-bottom: 1px solid rgba(255,255,255,0.1);
       min-height: 94px; 
       max-height: 94px;
       box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    .poi-info h4 { 
        margin: 0; 
        font-size: 18px; 
        font-weight: 700; 
        color: #fff; 
        text-shadow: 0 1px 2px rgba(0,0,0,0.2);
        letter-spacing: -0.5px;
    }
    .poi-info .badge { 
        font-size: 11px; 
        color: #fff;
        background: rgba(255,255,255,0.2);
        padding: 2px 8px;
        border-radius: 4px;
        font-weight: 700; 
        letter-spacing: 0.5px; 
        display: inline-block; 
        margin-top: 6px; 
        text-transform: uppercase;
    }
    
    .header-actions {
       display: flex;
       gap: 12px;
    }

    .action-btn { 
       background: rgba(255,255,255,0.15); 
       border: 1px solid rgba(255,255,255,0.2); 
       color: white; 
       cursor: pointer; 
       display: flex; 
       align-items: center; 
       justify-content: center;
       width: 38px; 
       height: 38px; 
       border-radius: 50%;
       transition: all 0.2s ease;
    }
    .action-btn:hover { background: rgba(255,255,255,0.25); transform: translateY(-2px); }
    .action-btn.close-fully { background: rgba(0, 0, 0, 0.2); border-color: rgba(255, 255, 255, 0.3); }
    .action-btn.close-fully:hover { background: #ef4444; border-color: #ef4444; color: #fff; }

    .poi-content { flex: 1; background: #f8fafc; position: relative; }
    iframe { width: 100%; height: 100%; border: none; display: block; }

    .poi-footer {
       padding: 15px 25px;
       background: #ffffff;
       border-top: 1px solid #e2e8f0;
       display: flex;
       justify-content: space-between;
       align-items: center;
       box-shadow: 0 -4px 10px rgba(0,0,0,0.02);
    }
    .external-link { 
       color: var(--primary, #1976D2); 
       text-decoration: none; 
       font-size: 14px; 
       font-weight: 600; 
       display: flex; 
       align-items: center; 
       gap: 8px; 
       transition: all 0.2s;
       padding: 6px 12px;
       border-radius: 6px;
       background: var(--primary-alpha, rgba(25, 118, 210, 0.05));
    }
    .external-link:hover { 
        background: var(--primary, #1976D2);
        color: #fff;
    }
    
    .nav-controls { display: flex; align-items: center; gap: 15px; }
    .nav-controls button { 
       background: #fff; 
       border: 1px solid #e2e8f0; 
       color: #334155; 
       border-radius: 8px; 
       width: 36px; 
       height: 36px; 
       cursor: pointer; 
       display: flex; 
       align-items: center; 
       justify-content: center; 
       font-size: 20px; 
       transition: all 0.2s;
       box-shadow: 0 2px 5px rgba(0,0,0,0.05);
    }
    .nav-controls button:hover:not(:disabled) { 
        border-color: var(--primary, #1976D2);
        color: var(--primary, #1976D2);
        transform: translateY(-1px);
    }
    .nav-controls button:disabled { opacity: 0.3; cursor: default; }
    
    .dots { display: flex; gap: 8px; }
    .dots span { width: 10px; height: 10px; border-radius: 50%; background: #cbd5e1; cursor: pointer; transition: all 0.3s; }
    .dots span.active { background: var(--primary, #1976D2); transform: scale(1.2); }
  `]
})
export class PoiSidebarComponent {
   dataChat = inject(DataChatService);
   sanitizer = inject(DomSanitizer);

   isCollapsed = signal(false);

   // Computed signal to cache the safe URL and prevent reloads on random change detection (e.g. mouse moves)
   iframeSrc = computed(() => {
      const poi = this.currentPoi;
      return this.getSafeUrl(poi?.poi_url || poi?.url);
   });

   get currentPoi() {
      return this.dataChat.poiList()[this.dataChat.activePoiIndex()];
   }

   getSafeUrl(url: string | undefined): SafeResourceUrl {
      if (!url) {
         console.warn('[PoiSidebar] No URL provided for POI');
         return '';
      }
      // Asegurar ruta absoluta si es relativa para evitar ambigüedades
      let finalUrl = url.startsWith('http') ? url : window.location.origin + (url.startsWith('/') ? '' : '/') + url;

      // Añadir param iframe=true para evitar que la app hija resetee la sesión
      // Debemos insertarlo ANTES del fragmento (#) si existe
      if (finalUrl.includes('#')) {
         const hashIndex = finalUrl.indexOf('#');
         const base = finalUrl.substring(0, hashIndex);
         const fragment = finalUrl.substring(hashIndex); // Incluye el símbolo #
         const sep = base.includes('?') ? '&' : '?';
         finalUrl = `${base}${sep}iframe=true${fragment}`;
      } else {
         const sep = finalUrl.includes('?') ? '&' : '?';
         finalUrl = `${finalUrl}${sep}iframe=true`;
      }

      console.log('[PoiSidebar) Loading iframe URL:', finalUrl);
      return this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
   }

   close() {
      this.dataChat.isPoiSidebarOpen.set(false);
      this.isCollapsed.set(false); // Reset collapsed state when close
   }

   toggleCollapse() {
      this.isCollapsed.update(v => !v);
   }

   next() {
      this.dataChat.activePoiIndex.update(i => Math.min(this.dataChat.poiList().length - 1, i + 1));
   }

   prev() {
      this.dataChat.activePoiIndex.update(i => Math.max(0, i - 1));
   }

   setActive(i: number) {
      this.dataChat.activePoiIndex.set(i);
   }
}
